var global = window

var zoneMsg = [];
var zoneMsgCurrent = -1;
var zoneMsgInterval = null;

// ========================= Récupère les dimensions des fenêtres
global.getWindowHeight = function () {
    if (document.body.clientHeight) {
        return document.body.clientHeight;
    } else {
        return window.innerHeight;
    }
}

global.getWindowWidth = function () {
    if (document.body.clientWidth) {
        return document.body.clientWidth;
    } else {
        return window.innerWidth;
    }
}

global.refreshZoneMsg = function () {
    if (typeof $ !== 'undefined') {
        ajaxCall({
            method: "POST",
            url: "zoneMsg.php",
            dataType: 'json',
            success: function (json) {
                zoneMsg = json;
                if (zoneMsgCurrent < 0) zoneMsgNext();
                clearInterval(zoneMsgInterval);
                zoneMsgInterval = setInterval(function () {
                    zoneMsgNext();
                }, 3500);

                $('.menuZoneMsgList').html('');
                $.each(zoneMsg, function (i, element) {
                    $('.menuZoneMsgList').append(zoneMsgParse(this));
                });
                if (zoneMsg.length > 1) {
                    $('.menuZoneMsgOpen').show();
                }
                else {
                    $('.menuZoneMsgOpen, .menuZoneMsgList').hide();
                    $('.menuZoneMsgList').removeClass('active')
                    $('.menuZoneMsg').show();
                }
            }
        });
    }
}

global.zoneMsgNext = function () {
    if (zoneMsg.length > 0) {
        zoneMsgCurrent++;
        if (zoneMsgCurrent >= zoneMsg.length) zoneMsgCurrent = 0;

        var msg = zoneMsg[zoneMsgCurrent];
        if ($('.menuZoneMsg').find('> div').last().data('text') != msg.msg) {
            $('.menuZoneMsg').find('> div').fadeOut(400, function () {
                $(this).remove();
            });
            $('.menuZoneMsg').append(zoneMsgParse(msg));
            $('.menuZoneMsg').find('> div').last().data('text', msg.msg).hide().fadeIn(400);
        }
    }
    else {
        $('.menuZoneMsg').html('');
    }
}

global.zoneMsgParse = function (msg) {
    return '<div>' + ((msg.click) ? '<a href="javascript:;" onclick="zoneMsgListState(0); ' + msg.click + '">' : '<a>') + '<img src="assets/images/icons/white/' + msg.icon + '.png" /> ' + msg.msg + '' + ((msg.click) ? '</a>' : '</a>') + '</div>';
}

global.zoneMsgListState = function (state) {
    if (!state) {
        $('.menuZoneMsgOpen').removeClass('active')
        $('.menuZoneMsgList').slideUp(300, function () {
            $('.menuZoneMsg').show();
        });
    }
    else {
        $('.menuZoneMsgOpen').addClass('active')
        $('.menuZoneMsgList').slideDown();
        $('.menuZoneMsg').hide();
    }
}

$(function() {
    $('.menuZoneMsgOpen').click(function () {
        if ($('.menuZoneMsgOpen').hasClass('active')) {
            zoneMsgListState(0);
        }
        else {
            zoneMsgListState(1);
        }
    });
})


var menuCompactMode = false;

global.compactMenu = function (compactMode) {
    var logoPrefix = '';
    if (APP_ENV != 'production') {
        logoPrefix = 'dev_';
    }

    if (compactMode === false) {
        menuCompactMode = true;
    }
    else if (compactMode === true) {
        menuCompactMode = false;
    }

    if (menuCompactMode) {
        $('.sidebar').removeClass('sidebar--compact');
        $('#Contenu').removeClass('full');
        $('#modalLoading').removeClass('full');
        $('#loadingBox').removeClass('full');
        $('#compactMenuToggle').removeClass('sidebar__toggle--active');
        menuCompactMode = false;
    }
    else {
        $('.sidebar').addClass('sidebar--compact');
        $('#Contenu').addClass('full');
        $('#modalLoading').addClass('full');
        $('#loadingBox').addClass('full');
        $('#compactMenuToggle').addClass('sidebar__toggle--active');
        menuCompactMode = true;
    }
}

var operation_message_timeout;

global.operation_message = function (msg, result) {
    switch (result) {
        case 'error':
            msg = '<span class="error_message">' + msg + '</span>';
            break;
        case 'ok':
            msg = '<span style="color:#00cc00">' + msg + '</span>';
            break;
    }
    $('#errorDiv').stop().stop().css('left', '-200px').css('opacity', 0);
    $('#errorDiv').animate({
        left: "40px",
        opacity: 1
    }, 500);
    $('#errorDiv').html(msg);
    if (operation_message_timeout) clearTimeout(operation_message_timeout);
    operation_message_timeout = setTimeout(function () {
        $('#errorDiv').animate({
            left: "-200px",
            opacity: 0
        }, 500, function () {
            $(this).html('')
        });
    }, 5000);
}

global.operation_response = function (response) {
    response = jQuery.parseJSON(response);
    operation_message(response['msg'], response['result']);
}

var lastScroll = null;

global.scrollStore = function () {
    lastScroll = $(window).scrollTop();
    //$(window).scrollTop(0);
}

global.scrollRestore = function () {
    $(window).scrollTop(lastScroll);
    //lastScroll = null;
}

global.scrollReset = function () {
    $(window).scrollTop(0);
}

global.Imni = {
    Message: {
        afficheErreurMessage: function (message) {
            document.getElementById("ajaxErrorBox").style.display = 'block';
            document.getElementById("ajaxErrorBoxMessage").innerHTML = message;
        },

        afficheSuccesMessage: function (message) {
            document.getElementById("ajaxSuccesBox").style.display = 'block';
            document.getElementById("ajaxSuccesBoxMessage").innerHTML = message;
        },

        afficheDevResponse: function (message) {
            if (document.getElementById("ajaxDevResponseBox")) {
                document.getElementById("ajaxDevResponseBox").style.display = 'block';
                document.getElementById("ajaxDevResponseBoxMessage").innerHTML = message;
            }
        }
    }
}

/**
 * Tient en vie la session courante
 */
global.keep_alive = function () {
    const t = setTimeout(keep_alive, 5 * 60 * 100)
    global.refreshZoneMsg()
}

keep_alive()